import { AxiosResponse } from "axios";
import { axiosClient } from "../../axiosClient";
import { axiosSafeRequest } from "../../axiosSafeRequest";

type ApiResponse = AxiosResponse<Blob>;

/**
 * Download the latest installer for a given product.
 *
 * @param productId The entitled product id (e.g. "DigitalCNC-NX").
 * @param platform The release platform (e.g. "x64").
 * @returns An HTTP response carrying the MSI binary.
 */
export const apiDownloadLatestGet = async (productId: string, platform: string): Promise<ApiResponse | undefined> => {
  // Queuing the download typically takes ~10s, plus transfer time for the MSI.
  // A 2-minute whole-request timeout aborts a genuine hang (-> ECONNABORTED,
  // caught upstream) so the UI can recover, while leaving ample headroom for
  // the queue plus the MSI transfer on a normal connection.
  return axiosSafeRequest(() => axiosClient.get(`/release/${encodeURIComponent(productId)}/${platform}/latest`, { responseType: 'blob', timeout: 120000 }));
}
